import ForbiddenPage from '@pages/ForbiddenPage'
import { useCanAccessPath } from '@hooks/useCanAccessPath'
import { Outlet, useLocation } from 'react-router-dom'

/**
 * Route-level authorization, mounted once above every logged route.
 *
 * It reads the permission for the current path from ROUTE_PERMISSIONS, so
 * routes declare nothing themselves and the navigation reads the same source.
 * Blocking here — rather than inside the page — means the page component never
 * mounts, so its fetch effects never fire: an admin cannot issue a request the
 * API would refuse. That is what makes a background 403 rare rather than
 * merely survivable.
 *
 * `<Page permissions>` still guards individual pages that are not in the map.
 *
 * The check is synchronous, which is safe because this sits under
 * <LayoutLogged />, and that renders its outlet only once `currentUser` has
 * loaded — so permissions are always known by the time this runs.
 */
const RouteGate = () => {
  const { pathname } = useLocation()
  const { canAccessPath } = useCanAccessPath()

  return canAccessPath(pathname) ? <Outlet /> : <ForbiddenPage />
}

export default RouteGate
